__turbopack_context__.v({
  "applyFiltersPanelWrap": "drawer-filter-module-scss-module__TSGQrq__applyFiltersPanelWrap",
  "closeButton": "drawer-filter-module-scss-module__TSGQrq__closeButton",
  "count": "drawer-filter-module-scss-module__TSGQrq__count",
  "drawerTopPanel": "drawer-filter-module-scss-module__TSGQrq__drawerTopPanel",
  "mobileBottomPanel": "drawer-filter-module-scss-module__TSGQrq__mobileBottomPanel",
  "openFilterButton": "drawer-filter-module-scss-module__TSGQrq__openFilterButton",
});
